import React, { useEffect, useState, useRef } from "react";
import NudgeModal from "../../../HtmlElements/NudgeModal";
import {
  displayFormattedDate,
  getUserStatsObject,
  recordActivity,
  getUrlDetailsObj,
  getTabType
} from "../../../../services/commonService";
import { Accordion } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import RelevanceScore from "../../../HtmlElements/RelevanceScore";
import { useLocation, useParams } from "react-router-dom";
import SideCardNudgeDetails from "../../../HtmlElements/SideCardNudgeDetails";

export default function NudgesWithPromptTiles({
  activeUnitNudges,
  is_side_card,
  activeAccordion,
  setActiveAccordion,
  selectedItems,
  setSelectedItems,
  activeUnit,
}) {
  const { accountId, accountName } = useParams();
  const [copied, setCopied] = useState(false);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [nudgeModalData, setNudgeModalData] = useState([]);
  const [expandedCardId, setExpandedCardId] = useState(null);

  var pageParsedData = getUrlDetailsObj(useLocation, useParams);
  pageParsedData.query_params = {}
  pageParsedData.query_params.tab = 'nudges_and_events';
  var tab_name = getTabType('nudges_and_events') || "";

  // Refs to track each accordion item for scrolling
  const accordionRefs = useRef([]);

  const handleAccordionClick = (index) => {
    setActiveAccordion(!activeAccordion.toString()); // Close the currently open accordion if clicked
    let categoryName = activeUnitNudges[activeAccordion]?._id
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    let userStat = getUserStatsObject(
      tab_name+" - "+categoryName,
      "nudge_collapse",
      "Page Source: " + accountName,
      window.location.href,
      accountId
    );
    userStat.url_details = pageParsedData;
    recordActivity(userStat);

    if (activeAccordion?.toString() !== index.toString()) {
      categoryName = activeUnitNudges[index]?._id
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

        let userStat = getUserStatsObject(
          tab_name+" - "+categoryName,
          "nudge_expand",
          "Page Source: " + accountName,
          window.location.href,
          accountId
        );
        userStat.url_details = pageParsedData;
        recordActivity(userStat);

      setActiveAccordion(index.toString()); // Open newly clicked accordion
      accordionRefs.current[index].scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  };

  const handleCheckboxChange = (nudgeId) => {
    setSelectedItems((prevSelectedItems) =>
      prevSelectedItems.includes(nudgeId)
        ? prevSelectedItems.filter((id) => id !== nudgeId)
        : [...prevSelectedItems, nudgeId]
    );
  };

  // const handleCopyToClipboard = () => {
  //   console.log("SELCTED NUDGE: "+JSON.stringify(selectedItems));
  //   console.log("ACTIVE NUDGE: "+JSON.stringify(activeUnitNudges));
  //   const textToCopy = selectedItems
  //     .map((id) => {
  //       const nudge = activeUnitNudges.find((nudge) =>
  //         nudge.data[0].nudges.nudges.some((dataItem) => dataItem.id === id)
  //       );

  //       let userStat = getUserStatsObject(
  //         tab_name,
  //         "nudge_copy",
  //         "Page Source: " + accountName,
  //         window.location.href,
  //         accountId
  //       );
  //       userStat.url_details = pageParsedData;
  //       recordActivity(userStat);

  //       const dataItem = nudge?.data?.[0].nudges?.nudges?.find(
  //         (dataItem) => dataItem.id === id
  //       );

  //       return dataItem
  //         ? (dataItem?.event ? dataItem.event + "\n" : "") +
  //             dataItem?.potential_impact
  //         : "";
  //     })
  //     .join("\n\n");

  //   navigator.clipboard.writeText(textToCopy).then(() => {
  //     setCopied(true);
  //   });

  //   setTimeout(() => {
  //     setCopied(false);
  //   }, 2000);
  // };

  const handleMoreDetailCard = (nudgeId) => {
    setExpandedCardId(nudgeId);

    setTimeout(() => {
      const element = document.getElementById("card_detail_" + nudgeId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 30);
  };

  const handleCloseMoreDetailCard = () => {
    setExpandedCardId(null);
  };

  const handleMore = (nudgeData) => {
    setShowMoreModal(true);
    setNudgeModalData(nudgeData);

    const id = "nudges";
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleClose = () => {
    setShowMoreModal(false);
  };

  // Utility function to check if the date is within the last 4 months
  /*
  const isWithinLast4Months = (date) => {
    const currentDate = new Date();
    const targetDate = new Date(date);
    const diffInMonths =
      (currentDate.getFullYear() - targetDate.getFullYear()) * 12 +
      (currentDate.getMonth() - targetDate.getMonth());
    return diffInMonths <= 4;
  };
  */

  // Safari Compatible function below:
  const isWithinLast4Months = (date) => {
    if (!date) return false; // Handle invalid cases
  
    const currentDate = new Date();
    const targetDate = new Date(date.replace(/-/g, "/")); // Fix for Safari
    
    if (isNaN(targetDate)) return false; // Handle invalid dates
  
    const diffInMonths =
      (currentDate.getFullYear() - targetDate.getFullYear()) * 12 +
      (currentDate.getMonth() - targetDate.getMonth());

    return diffInMonths <= 4;
  };  

  // Sort the nudges by count (in descending order)
  const sortedNudges = activeUnitNudges
    .map((buNudge) => {
      const nudgeCount = buNudge?.data?.[0]?.nudges?.nudges?.filter((nudge) =>
        isWithinLast4Months(nudge.event_date)
      ).length;

      return {
        ...buNudge,
        nudgeCount,
      };
    })
    .sort((a, b) => b.nudgeCount - a.nudgeCount); // Sort by nudge count in descending order

  return (
    <>
      {/* <div className="copy_btn_block">
        <span
          className={`copy-message ${
            copied ? "copy-fade-in" : "copy-fade-out"
          }`}
        >
          Copied to clipboard!
        </span>

        {showMoreModal === true && (
          <span className="nudgeDetaiBackLink cursorP" onClick={handleClose}>
            {" "}
            Back{" "}
          </span>
        )}

        <button
          disabled={selectedItems.length === 0}
          className="copy_btn mt-0"
          onClick={handleCopyToClipboard}
        >
          <img src="/img/icons/copy.png" alt="logo" width="20" className="" />{" "}
          Copy <span>{selectedItems.length}</span> Items
        </button>
      </div> */}

      <div className="row grow_nudges">
        {sortedNudges.map((buNudge, index) =>
          is_side_card === true ? (
            <>
    {/* Only render if there are nudges */}
    {(buNudge?.data?.[0]?.nudges?.nudges?.filter((nudge) =>
                isWithinLast4Months(nudge.event_date)
              )?.length || 0) > 0 && (
      <>
        <h5
          className={`grow_nudges_head ${
            showMoreModal === true ? "d-none" : ""
          }`}
          id={buNudge?._id.split(" ").join("")}
        >
          {buNudge?._id
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")}
        </h5>

        {/* Filter nudges to show only the last 4 months */}
        {buNudge?.data?.[0]?.nudges?.nudges
          ?.filter((nudge) => {
            // Check if nudge is within the last 4 months
            const currentDate = new Date();
            const targetDate = new Date(nudge.event_date);
            const diffInMonths =
              (currentDate.getFullYear() - targetDate.getFullYear()) * 12 +
              (currentDate.getMonth() - targetDate.getMonth());
            return diffInMonths <= 4; // Only show nudges within 4 months
          })
          // Sort nudges by event_date in descending order (most recent first)
          .sort((a, b) => new Date(b.event_date) - new Date(a.event_date))
          .map((nudge, index_2) => (
            <div
              className={`nudge-card ${
                expandedCardId === nudge?.id ? "expanded" : "collapsed"
              }`}
              key={index_2 + "_" + index}
            >
              {expandedCardId === nudge?.id && (
                <SideCardNudgeDetails
                  nudgeData={nudge}
                  handleClose={handleCloseMoreDetailCard}
                  handleCheckboxChange={handleCheckboxChange}
                  selectedItems={selectedItems}
                />
              )}

              {expandedCardId !== nudge?.id && (
                <div
                  className={`nudges_subblock ${
                    nudge?.impact_score >= 8 ? "custom_active" : ""
                  } `}
                >
                  <div className="checkbox_block">
                    <Form.Check
                      aria-label="option 1"
                      onChange={() => handleCheckboxChange(nudge?.id)}
                      checked={selectedItems.includes(nudge?.id)}
                    />
                  </div>
                  <div className="content_ndges">
                    <div className="content_para">
                      {nudge?.event && (
                        <h5
                          className="content_main_head cursorP"
                          onClick={() => handleMoreDetailCard(nudge?.id)}
                        >
                          {nudge?.event}
                        </h5>
                      )}
                      <div className="content_nudges_para">
                        {nudge.potential_impact}
                      </div>
                      <div className="date_company_impact_block">
                        {nudge?.impact_score && (
                          <div className="impact_company_block">
                            <div className="impact_score">
                              {nudge?.impact_score ? (
                                <RelevanceScore
                                  relevanceScore={nudge?.impact_score}
                                  section="impact_score"
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}

                        {nudge?.event_date && (
                          <span className="date_italic">
                            {displayFormattedDate(
                              nudge.event_date,
                              "YYYY-MM-DD",
                              true
                            )}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {nudge?.impact_score >= 8 && (
                    <div className="contet_head_img">
                      <img
                        src="/img/icons/trending-up_backcolor.png"
                        alt="image"
                        className="image_block"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
      </>
    )}
  </>
          ) : (
            <Accordion
              activeKey={activeAccordion?.toString()}
              key={index}
              className="custom_accordian"
            >
              {(buNudge?.data?.[0]?.nudges?.nudges?.filter((nudge) =>
                isWithinLast4Months(nudge.event_date)
              )?.length || 0) > 0 && (
                <Accordion.Item
                  eventKey={index?.toString()}
                  key={index}
                  ref={(el) => (accordionRefs.current[index] = el)}
                >
                  <Accordion.Header onClick={() => handleAccordionClick(index)}>
                    <h6 className="accordian_head">
                      <img
                        src="/img/icons/zap_green.png"
                        alt="logo"
                        width="16"
                        className="mr-2"
                      />
                      {buNudge?._id
                        .split("_")
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(" ")}{" "}
                      ({buNudge?.data?.[0]?.nudges?.nudges?.filter((nudge) =>
                        isWithinLast4Months(nudge.event_date)
                      )?.length || 0})
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      {buNudge?.data?.[0]?.nudges?.nudges
                        ?.filter((nudge) =>
                          isWithinLast4Months(nudge.event_date)
                        )
                        .sort((a, b) => new Date(b.event_date) - new Date(a.event_date))
                        .map((nudge, index_2) => (
                          <div className="col-md-4" key={index_2}>
                            <div
                              className={`nudges_subblock ${
                                nudge?.impact_score >= 8 ? "custom_active" : ""
                              } `}
                            >
                              <div className="checkbox_block">
                                <Form.Check
                                  aria-label="option 1"
                                  onChange={() => handleCheckboxChange(nudge?.id)}
                                  checked={selectedItems.includes(nudge?.id)}
                                />
                              </div>
                              <div className="content_ndges"
                               onClick={() => {
                                handleMore(nudge)}}
                              >
                                <div className="content_para">
                                  <div className="content_nudges_para">
                                    {nudge?.event && (
                                      <h5
                                        className="content_main_head"
                                       
                                      >
                                        {nudge?.event}
                                      </h5>
                                    )}
                                    <div className="nudges_para_custom">
                                      {nudge.potential_impact}
                                    </div>
                                    <div className="date_company_impact_block">
                                      <div className="impact_company_block">
                                        <div className="impact_score">
                                          {nudge?.impact_score ? (
                                            <RelevanceScore
                                              relevanceScore={nudge?.impact_score}
                                              section="impact_score"
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                      {nudge?.event_date && (
                                        <span className="date_italic">
                                          {displayFormattedDate(
                                            nudge.event_date,
                                            "YYYY-MM-DD",
                                            true
                                          )}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {nudge?.impact_score >= 8 && (
                                <div className="contet_head_img">
                                  <img
                                    src="/img/icons/trending-up_backcolor.png"
                                    alt="image"
                                    className="image_block"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              )}
            </Accordion>
          )
        )}
      </div>

      {showMoreModal && is_side_card !== true && (
        <NudgeModal
          nudgeData={nudgeModalData}
          handleClose={handleClose}
          is_side_card={is_side_card}
        />
      )}
    </>
  );
}
